export default "__VITE_ASSET__301fa346__"